<template>
    <div>
        <router-link :to="{name:'deposit_request_details', params:{hashid:row.id, gateway_source : gatewaySource}}"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.details') }}</span>
                <i class="fa fa-eye"></i>
            </div>
        </router-link>

    </div>
</template>

<script>
import Vue from 'vue'
// import {depositService} from '@/common/api.service'
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";
import {requestStatusStr, requestStatus} from '@/constants/deposit'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            loading: true,
            data: {},
            requestStatusStr,
            requestStatus
        }
    },
    methods: {},
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
})
</script>

<style>

</style>